import { useTranslation } from 'react-i18next';
import styles from './Consumption.module.css';

const Consumption = ({ amount }) => {
  const { t } = useTranslation();

  if (amount <= 0) return;

  return (
    <div className={`${styles.consumption} text-center mt-4`}>
      {t('consumptionIncluded', {
        consumption: '$' + amount,
      })}
    </div>
  );
};

export default Consumption;
